import {create, createStore} from 'zustand';

interface ChartViewStore {
  type: string;

  isPrimaryFullWidth: () => boolean;
  setType: (type: string) => void;
}

export const useChartViewStore = create<ChartViewStore>((set, get) => ({
  type: 'common',

  isPrimaryFullWidth: () => get().type === 'part',
  setType: (type) => set({type}),
}));

export const createChartViewStore = () =>
  createStore<ChartViewStore>((set, get) => ({
    type: 'common',

    isPrimaryFullWidth: () => get().type === 'part',
    setType: (type) => set({type}),
  }));
